import React, { Component } from 'react';
/* CSS */
import '../../../../Assets/EnsembleStyles/EnsHome.css';

/* Components */
import NavigationBar from '../../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';                                    /* Navigation Bar */
import TitleBar from '../../../EnsembleComponents/Common/Layouts/TitleBar/TitleBar';                                              /* Titile  Bar */



// SubRouting
import TenantServices from '../../Common/Layouts/SubRouting/EnsembleMainContainer';

/* Side Bar */


/* Footer */
import Footer from '../../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import Idle from 'react-idle';
import InactiveWindow from '../../../Logout/InActive';
import {Modal } from 'reactstrap';
import { connect } from 'react-redux';



class NewRequest extends Component {
    showSettings(event) {
        event.preventDefault();
    }

    componentDidMount(){
        let StateVal = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        this.setState({OnPremisesState:StateVal});
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
            this.setState({ LogOffTime : Number(E_LogoffTime) });
        }
    }

    componentWillReceiveProps(nextProps){
        if (this.props !== nextProps) {          
            let StateVal = (nextProps.OnPremises !== undefined && nextProps.OnPremises !== null) ? nextProps.OnPremises : false;
            this.setState({OnPremisesState:StateVal});
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            sideSize: 300,
            drag: 300,
            inactive_modal: false,
            OnPremisesState: false,
            LogOffTime: 1200000
        }
        this.toggleSide = this.toggleSide.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.Inactivetoggle = this.Inactivetoggle.bind(this);

    }

    toggleSide(action) {
        switch (action) {
            case "open": this.setState({ sideSize: 200, drag: 200 });
                break;
            case "close": this.setState({ sideSize: 1, drag: 1 });
                break;
            default : break;
        }

    }

    handleDrag(width) {
        this.setState({ drag: width + 10 });
    }



    Inactivetoggle() {
        this.setState({
            inactive_modal: !this.state.inactive_modal
        });
    }

    Extend_Session = (someArg) => {
        this.setState({
            inactive_modal: false
        });
    }


    render(OnPremises) {
        
        return (
            <div className={!this.state.OnPremisesState ? "EnsembleTenant":"Ensemble"}>

                <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
                    if (idle && !this.state.OnPremisesState) {
                        this.setState({ inactive_modal: true });
                    }
                }} />

                {/* Navigation Bar && Title bar displays the title of the page */}
                {
                    !this.state.OnPremisesState ? <div><NavigationBar /> 
                        <TitleBar parentToChildData={"Tenant Services"} istabView={false} />
                        </div>
                    : ""
                }

                <div className={!this.state.OnPremisesState ? "margin_top" : "Ensemble_Content_FullPage"}>
                    <TenantServices match={this.props.match} />
                </div>

                <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={"ModalContainer InActive_Short_Modal"} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                </Modal>
                {
                    !this.state.OnPremisesState ? <Footer /> : ""
                }
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise
    };
};

export default connect(mapStateToProps, null)(NewRequest);
